export default __webpack_public_path__ + "static/media/responsive.1eefdd9f.jpg";